import React, { useState, useEffect } from "react";
import {
  Box,
  TextField,
  Typography,
  MenuItem,
  Button,
  Drawer,
  IconButton,
  Collapse,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Dialog,
  Tooltip,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { styled } from "@mui/material/styles";
import { api, get, post, put } from "../../../../utils/api";
import { fuelConsumptionUnits, FuelTypeEnum } from "../../../../utils/constant";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import DeleteIcon from "@mui/icons-material/Delete";
import EditDialog from "../../../../Components/Common/EditDialog";
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: "55%",
      overflowY: "auto",
    },
  },
};

/** Sentinel value for Fuel type select when nothing is chosen (must match disabled MenuItem). */
const FUEL_TYPE_PLACEHOLDER_VALUE = "Tap to select";

function AddEquipment(props) {
  const [alreadyFacility, setAlreadyFacility] = useState(false);
  const [facilities, setFacilities] = useState(["Select"]); // Store list of facilities
  const [equipmentType, setEquipmentType] = useState(["Select"]); // Store list of facilities
  const [fuelType, setFuelType] = useState(["Select"]); // Store list of facilities
  const [unitConsumption, setUnitConsumption] = useState(["Select"]); // Store list of facilities
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [deleteIndex, setDeleteIndex] = useState(null); // to track which equipment is being deleted
  const [industrialProcess, setIndustryProcess] = useState(["Select"]); // Store list of facilities

  const [equipments, setEquipments] = useState([]);
  const [noOfEquipment, setNoOfEquipment] = useState("");
  const [UnitofFuelConsumption, setUnitofFuelConsumption] = useState();
  useEffect(() => { }, [deleteIndex]);

  useEffect(() => {
    if (props?.selectedEquipment) {
      setEquipments(props?.selectedEquipment?.equipments);
      setNoOfEquipment(props?.selectedEquipment?.noOfEquipment ?? "");
      setUnitofFuelConsumption(
        props?.selectedEquipment?.equipments[0]?.unitOfFuelConsumption
      );
    }
  }, [props]);
  const [editDialog, setEditDialog] = useState(false);
  const [formData2, setFormData2] = useState([]);

  // Dynamically toggle collapse for each equipment
  const [openMachines, setOpenMachines] = useState(
    new Array(equipments.length).fill(false)
  );
  const [showAddForm, setShowAddForm] = useState(false);
  const [newEquipmentType, setNewEquipmentType] = useState("");
  const initialState = {
    location: "",
    facility: "",
    industrialProcess: "",
    equipmentType: "",
    name: "",
    fuelType: "",
    noOfEquipment: "",
    remark: "",
    equipments: [],
  };

  const [errors, setErrors] = useState({});
  const [fromValue, setFromValue] = useState(initialState);

  useEffect(() => {
    fetchFacilities();
    const state = {
      location: props?.selectedEquipment?.location ?? "",
      facility: props?.selectedEquipment?.facility?._id ?? "",
      industrialProcess: props?.selectedEquipment?.industrialProcess?._id ?? "",
      equipmentType: props?.selectedEquipment?.equipmentType?._id ?? "",
      name: props?.selectedEquipment?.name ?? "",
      fuelType: props?.selectedEquipment?.fuelType ?? "",
      equipments: props?.selectedEquipment?.equipments ?? [],
      noOfEquipment: props?.selectedEquipment?.noOfEquipment ?? "",
      remark: props?.selectedEquipment?.remark ?? "",
    };
    setFromValue(state);
    setFormData2(state);
    setAlreadyFacility(props?.selectedEquipment === null ? false : true);
    setEquipments(props?.selectedEquipment?.equipments ?? []);
  }, [props.selectedEquipment]);

  useEffect(() => {
    const next = equipments.length === 0 ? "" : equipments.length;
    setNoOfEquipment(next);
    setFromValue((prev) => ({
      ...prev,
      noOfEquipment: next === "" ? "" : next,
    }));
  }, [equipments]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Update form value state
    setFromValue((prev) => ({
      ...prev,
      [name]:
        name === "noOfEquipment"
          ? value === "" || value === undefined
            ? ""
            : Number(value)
          : value,
    }));

    // Handle dynamic changes based on specific field names
    switch (name) {
      case "noOfEquipment": {
        const numOfForms =
          value === "" || value === undefined
            ? 0
            : parseInt(String(value), 10);
        const safeCount = Number.isFinite(numOfForms)
          ? Math.min(100, Math.max(0, numOfForms))
          : 0;
        const unit =
          fromValue?.fuelType === "Natural Gas" ||
            fromValue?.fuelType === "Coal"
            ? "Kg per hour"
            : ["Petroleum/Gasoline", "Diesel", "Fuel Oil", "LPG", "Propane"].includes(
              fromValue?.fuelType
            )
              ? "Ltr per hour"
              : "";

        const equipmentArray = Array.from({ length: safeCount }, () => ({
          uniqueID: "",
          brand: "",
          model: "",
          ratedFuelConsumption: "",
          unitOfFuelConsumption: unit,
        }));

        setEquipments(equipmentArray);
        break;
      }

      case "fuelType": {
        const unit =
          value === "Natural Gas" || value === "Coal"
            ? "Kg per hour"
            : ["Petroleum/Gasoline", "Diesel", "Fuel Oil", "LPG", "Propane"].includes(value)
              ? "Ltr per hour"
              : "";

        setUnitofFuelConsumption(unit);

        // Update all equipment's unitOfFuelConsumption
        setEquipments((prevEquipments) =>
          prevEquipments.map((equipment) => ({
            ...equipment,
            unitOfFuelConsumption: unit,
          }))
        );

        // Clear unitOfFuelConsumption error if exists
        if (errors["unitOfFuelConsumption"]) {
          setErrors((prevErrors) => ({
            ...prevErrors,
            unitOfFuelConsumption: "", // Clear specific error
          }));
        }
        break;
      }

      case "equipmentType": {
        setShowAddForm(value === "other");
        break;
      }

      default:
        break;
    }

    // Clear errors for the specific field if they exist
    if (errors[name]) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        [name]: "", // Clear the specific field error
      }));
    }
  };


  const handleDeleteAgree = () => {
    // if (selectedDeleteIndex !== null) {
    //   const updatedEquipments = equipments.filter((_, index) => index !== selectedDeleteIndex);
    //   setEquipments(updatedEquipments);
    //   setSelectedDeleteIndex(null);
    //   setNumberOfMachines(updatedEquipments.length);
    // }
    setEquipments((prevEquipments) => {
      const updatedEquipments = [...prevEquipments];
      updatedEquipments.splice(deleteIndex, 1);
      return updatedEquipments;
    });

    // Optionally update the collapse state if needed
    setOpenMachines((prevOpenMachines) => {
      const updatedOpenMachines = [...prevOpenMachines];
      updatedOpenMachines.splice(deleteIndex, 1);
      return updatedOpenMachines;
    });
    setDeleteDialog(false);
    setDeleteIndex(null);
  };

  const handleAddClick = async () => {
    if (newEquipmentType.trim()) {
      try {
        const response = await post(`/master/addEquipmentType`, {
          name: newEquipmentType,
        });
        if (response?.data?.data) {
          // refreshEquipmentTypes(); // Refresh the equipment type options if needed
          setNewEquipmentType(""); // Clear input
          setShowAddForm(false); // Hide the form
          // fetchFacilities();
          getAllEQuipment();
          // props.setsnackOpen({
          //   open: true,
          //   message: "Equipment created successfully",
          //   severity: "success",
          // });
        }
      } catch (error) {
        props.setsnackOpen({
          open: true,
          message: "Equipment already exists",
          severity: "error",
        });
        setNewEquipmentType(""); // Clear input
        setShowAddForm(false);
      }
    }
  };

  const deleteEquipment = (index) => {
    setDeleteIndex(index);
    setDeleteDialog(true);
  };

  const toggleEquipment = (index) => {
    const updatedOpen = [...openMachines];
    updatedOpen[index] = !updatedOpen[index];
    setOpenMachines(updatedOpen); //
  };

  /** Non-empty trimmed IDs only; marks every index that shares a duplicate value. */
  const getUniqueIdDuplicateErrors = (list = []) => {
    const errorsMap = {};
    const msg =
      "Same Unique ID cannot be used for more than one equipment. Each equipment must have a distinct ID.";
    const trimmedIds = list.map((eq) => String(eq?.uniqueID ?? "").trim());
    const idToIndices = new Map();
    trimmedIds.forEach((id, idx) => {
      if (!id) return;
      if (!idToIndices.has(id)) idToIndices.set(id, []);
      idToIndices.get(id).push(idx);
    });
    idToIndices.forEach((indices) => {
      if (indices.length > 1) {
        indices.forEach((i) => {
          errorsMap[`equipment_${i}_uniqueID`] = msg;
        });
      }
    });
    return errorsMap;
  };

  const handleFieldChange = (index, field, value) => {
    const updatedEquipments = [...equipments];
    updatedEquipments[index][field] = value;

    if (field === "ratedFuelConsumption") {
      // Allow only numeric values
      const numericValue = value.replace(/[^0-9.]/g, ""); // Only allow numbers and decimal point
      updatedEquipments[index][field] = numericValue;

      // Validate numeric input for the Rated Fuel Consumption
      if (
        numericValue.trim() === "" ||
        isNaN(numericValue) ||
        parseFloat(numericValue) <= 0
      ) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          [`equipment_${index}_ratedFuelConsumption`]: `Rated Fuel Consumption must be a valid positive number for Equipment ${index + 1
            }.`,
        }));
      } else {
        // Clear the specific field error if the input is valid
        setErrors((prevErrors) => ({
          ...prevErrors,
          [`equipment_${index}_ratedFuelConsumption`]: "",
        }));
      }
    } else {
      updatedEquipments[index][field] = value;

      if (field === "uniqueID") {
        setEquipments(updatedEquipments);
        setErrors((prevErrors) => {
          const next = { ...prevErrors };
          const dupMap = getUniqueIdDuplicateErrors(updatedEquipments);
          updatedEquipments.forEach((eq, i) => {
            const key = `equipment_${i}_uniqueID`;
            const trimmed = String(eq?.uniqueID ?? "").trim();
            if (!trimmed) {
              next[key] = `Unique ID is required for Equipment ${i + 1}.`;
            } else {
              next[key] = dupMap[key] || "";
            }
          });
          return next;
        });
        return;
      }

      // Clear the specific field error if it exists
      if (errors[`equipment_${index}_${field}`]) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          [`equipment_${index}_${field}`]: "", // Clear the specific field error
        }));
      }
    }

    setEquipments(updatedEquipments);
  };

  const addMoreEquipment = () => {
    const newEquipment = {
      uniqueID: "",
      brand: "",
      model: "",
      ratedFuelConsumption: "",
      unitOfFuelConsumption: UnitofFuelConsumption,
    };

    // Add new equipment and update state
    setEquipments((prevEquipments) => [...prevEquipments, newEquipment]);
    // Update openMachines state to include a new entry
    setOpenMachines((prevOpenMachines) => [...prevOpenMachines, false]);
  };

  const getDropDownFieldId = (data) => {
    if (typeof data === "string") {
      return data; // If it's a direct ID, return it
    }
    return data?._id || ""; // If it's an object, return the _id
  };

  const fetchFacilities = async () => {
    try {
      let response = await get("/master/getAllFacility");

      const equipmentTypeResponse = await get("/master/getAllEquipmentType");

      setFacilities(response.data.data);
      setEquipmentType(equipmentTypeResponse.data.data);
      setFuelType(FuelTypeEnum);
      setUnitConsumption(fuelConsumptionUnits);
    } catch (error) {
      console.log("Error fetching facilities:", error);
    }
  };

  const getAllEQuipment = async () => {
    try {
      const equipmentTypeResponse = await get(`/master/getAllEquipmentType`);
      setEquipmentType(equipmentTypeResponse.data.data);
    } catch (error) {
      console.log("Error fetching facilities:", error);
    }
  };

  useEffect(() => {
    getAllIndustryProcess();
  }, []);

  const getAllIndustryProcess = async () => {
    try {
      const equipmentTypeResponse = await get(
        `/master/getAllIndustrialProcess`
      );
      setIndustryProcess(equipmentTypeResponse.data.data);
    } catch (error) {
      console.log("Error fetching facilities:", error);
    }
  };

  const Save = async () => {
    if (!validateForm()) {
      return;
    }
    try {
      const updatedNoOfEquipment = equipments.length;
      const dataToSubmit = {
        ...fromValue,
        equipments: equipments,
        noOfEquipment: updatedNoOfEquipment,
      };

      const url = alreadyFacility
        ? `${api}/master/updateIndustrialEquipment?id=${props.selectedEquipment?._id}`
        : `${api}/master/addIndustrialEquipment`;

      const response = alreadyFacility
        ? await put(url, dataToSubmit)
        : await post(url, dataToSubmit);

      handleExitAgree();
      props.setAddFacility(false);
      props.setsnackOpen({
        open: true,
        message: response?.data?.message,
        severity: "success",
      });
      props.fetchFacilities();
    } catch (err) {
      console.log(err);
      // if (err?.response?.data?.message) {
      //   if (err?.response?.data?.statusCode === 0) {
      //     setErrors((prevErrors) => ({
      //       ...prevErrors,
      //       name: "Industrial Equipment Already exists.",
      //     }));
      //   } else {
      //     props.setsnackOpen({
      //       open: true,
      //       message: err.response.data.message,
      //       severity: "error",
      //     });
      //   }
      // }
      props.setsnackOpen({
        open: true,
        message:
          err?.response?.data?.message || "An error occurred while saving data",
        severity: "error",
      });
    }
  };

  const validateForm = () => {
    const newErrors = {};
    const { location, facility, equipmentType, name, fuelType, noOfEquipment } =
      fromValue;

    // Validate main fields
    if (!location || location.trim() === "") {
      newErrors.location = "Location is required.";
    }

    // if (!facility || facility === "Select") {
    //   newErrors.facility = "Please select a facility.";
    // }

    if (
      !equipmentType ||
      equipmentType === "Select" ||
      equipmentType === "other"
    ) {
      newErrors.equipmentType = "Please select an equipment type.";
    }

    if (!name || name.trim() === "") {
      newErrors.name = "Equipment name is required.";
    }

    if (!fuelType || fuelType.trim() === "" || fuelType === FUEL_TYPE_PLACEHOLDER_VALUE) {
      newErrors.fuelType = "Fuel type is required.";
      newErrors.unitOfFuelConsumption = "Unit Of Fuel Consumption is required.";
    }

    if (
      (!noOfEquipment ||
        isNaN(noOfEquipment) ||
        parseInt(noOfEquipment) <= 0) &&
      equipments.length === 0
    ) {
      newErrors.noOfEquipment = "Number of equipment must be a valid number.";
    } else if (equipments.length === 0) {
      newErrors.noOfEquipment = "Number of equipment must be a valid number.";
    }

    // Validate each equipment form
    equipments.forEach((equipment, index) => {
      if (!equipment.uniqueID || equipment.uniqueID.trim() === "") {
        newErrors[
          `equipment_${index}_uniqueID`
        ] = `Unique ID is required for Equipment ${index + 1}.`;
      }
      if (!equipment.brand || equipment.brand.trim() === "") {
        newErrors[
          `equipment_${index}_brand`
        ] = `Brand is required for Equipment ${index + 1}.`;
      }
      if (!equipment.model || equipment.model.trim() === "") {
        newErrors[
          `equipment_${index}_model`
        ] = `Model is required for Equipment ${index + 1}.`;
      }
      if (
        !equipment.ratedFuelConsumption ||
        equipment.ratedFuelConsumption.trim() === ""
      ) {
        newErrors[
          `equipment_${index}_ratedFuelConsumption`
        ] = `Rated Fuel Consumption is required for Equipment ${index + 1}.`;
      }
      // if (
      //   !equipment.unitOfFuelConsumption ||
      //   equipment.unitOfFuelConsumption.trim() === ""
      // ) {
      //   newErrors[
      //     `equipment_${index}_unitOfFuelConsumption`
      //   ] = `Unit of Fuel Consumption is required for Equipment ${index + 1}.`;
      // }
    });

    // Duplicate Unique IDs (trimmed, ignore empty)
    const dupUniqueIdErrors = getUniqueIdDuplicateErrors(equipments);
    Object.assign(newErrors, dupUniqueIdErrors);

    console.log("newErrors: " + newErrors);

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleClose = () => {
    const isFormDataUnchanged = Object.keys(fromValue).every(
      (key) => fromValue[key] === formData2[key]
    );

    if (isFormDataUnchanged) {
      handleExitAgree();
    } else {
      setEditDialog(true);
    }
  };

  const handleExitAgree = () => {
    setFromValue(
      props.selectedEquipment === null ? initialState : props.selectedFacility
    );
    props.setAddFacility(false);
    props.fetchFacilities();
    setFormData2(
      props.selectedEquipment === null ? initialState : props.selectedFacility
    );
    setEquipments([]); // Reset equipments
    setNoOfEquipment("");
    setOpenMachines([]); // Reset open machines state if necessary
    setErrors({}); // Clear any existing errors
    setAlreadyFacility(false);
    setShowAddForm(false);
    setNewEquipmentType("");
    setUnitofFuelConsumption();
    setEditDialog(false);
    // setFromValue({});
  };

  const list = () => (
    <Box
      display="flex"
      gap={3}
      sx={{
        width: "26.5rem",
        maxWidth: "100%",
        // width: 400,
        // maxWidth:"100%",
        height: "100vh",
        display: "flex",
        justifyContent: "space-btween",
        backgroundColor: "transparent",
      }}
    >
      {editDialog && (
        <EditDialog {...{ editDialog, setEditDialog, handleExitAgree }} />
      )}
      <Box
        sx={{
          backgroundColor: "#fff",
          height: "3%",
          padding: "13px",
          margin: "30px 0 0 0",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "80%",
          width: "5%",
        }}
      >
        <IconButton
          onClick={() => {
            handleClose();
          }}
          sx={{ color: "black" }}
        >
          <CloseIcon sx={{ fontSize: "1.2rem" }} />
        </IconButton>
      </Box>
      <Box
        sx={{
          padding: "24px",
          backgroundColor: "#fff",
          height: "100%",
          width: "100%",
          overflowY: "scroll",
        }}
      >
        <Typography
          variant="h6"
          sx={{
            textDecoration: "underline",
            fontWeight: "bold",

            mb: 2,
          }}
        >
          {props?.selectedEquipment?._id === undefined
            ? "Add Industrial Equipment"
            : "Edit Industrial Equipment"}
        </Typography>

        <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 1 }}>
          Location
        </Typography>

        <CustomTextField
          //   select
          variant="outlined"
          value={fromValue?.location}
          onChange={handleChange}
          fullWidth
          name="location"
          placeholder="Enter Name"
          error={!!errors?.location} // Show error styling if there's an error
          InputLabelProps={{
            style: { color: errors.location ? "#D34040" : undefined },
          }}
          disabled={
            props.selectedEquipment?.location === undefined ? false : true
          }
        ></CustomTextField>
        {errors.location && (
          <Typography variant="body2" color="#D34040">
            {errors.location}
          </Typography>
        )}

        <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 1 }}>
          Industrial Process
        </Typography>
        <CustomTextField
          select
          variant="outlined"
          value={
            fromValue?.industrialProcess === "" || undefined
              ? "Tap to Select"
              : getDropDownFieldId(fromValue?.industrialProcess)
          }
          onChange={handleChange}
          fullWidth
          name="industrialProcess"
          placeholder="Tap to Select"
          error={!!errors.industrialProcess} // Show error styling if there's an error
          InputLabelProps={{
            style: { color: errors.industrialProcess ? "#D34040" : undefined },
          }}
          SelectProps={{ MenuProps }}
          disabled={
            props.selectedEquipment?.industrialProcess === undefined
              ? false
              : true
          }
        >
          <MenuItem
            value={
              fromValue?.industrialProcess === "" || undefined
                ? "Tap to Select"
                : fromValue?.industrialProcess
            }
            disabled
          >
            {fromValue?.industrialProcess === "" || undefined
              ? "Tap to Select"
              : fromValue?.industrialProcess?.industryProcess}
          </MenuItem>{" "}
          {industrialProcess?.map((item, i) => (
            <MenuItem
              key={i}
              value={item._id}
              sx={{
                maxWidth: "289px", // Ensure a fixed width
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                display: "block", // Ensure block layout
              }}
            >
              {item.industryProcess}
            </MenuItem>
          ))}
        </CustomTextField>

        <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 1 }}>
          Equipment Type
        </Typography>
        <CustomTextField
          select
          variant="outlined"
          value={
            fromValue?.equipmentType === "" || undefined
              ? "Tap to Select"
              : getDropDownFieldId(fromValue?.equipmentType)
          }
          onChange={handleChange}
          fullWidth
          name="equipmentType"
          placeholder="Tap to Select"
          error={!!errors.equipmentType} // Show error styling if there's an error
          InputLabelProps={{
            style: { color: errors.equipmentType ? "#D34040" : undefined },
          }}
          SelectProps={{ MenuProps }}
          disabled={
            props.selectedEquipment?.equipmentType === undefined ? false : true
          }
        >
          <MenuItem
            value={
              fromValue?.equipmentType === "" || undefined
                ? "Tap to Select"
                : fromValue?.equipmentType
            }
            disabled
          >
            {fromValue?.equipmentType === "" || undefined
              ? "Tap to Select"
              : fromValue?.equipmentType?.name}
          </MenuItem>{" "}
          {equipmentType?.map((item, i) => (
            // <Tooltip key={i} title={item.name} placement="top" arrow>
            <MenuItem
              key={i}
              value={item._id}
              sx={{
                maxWidth: "289px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                display: "block",
              }}
            >
              {item.name}
            </MenuItem>
            // </Tooltip>
          ))}
          <MenuItem onClick={() => setShowAddForm(true)} value="other">
            Other
          </MenuItem>
        </CustomTextField>
        {showAddForm && (
          <Box sx={{ mt: 1 }}>
            <CustomTextField
              variant="outlined"
              fullWidth
              placeholder="Enter name"
              value={newEquipmentType}
              onChange={(e) => setNewEquipmentType(e.target.value)}
            />

            <Button
              variant="contained"
              sx={{
                backgroundColor: "#0a3f73",
                textTransform: "none",
                marginTop: "3%",
              }}
              onClick={handleAddClick}
            >
              Add
            </Button>
          </Box>
        )}
        {errors.equipmentType && (
          <Typography variant="body2" color="#D34040">
            {errors.equipmentType}
          </Typography>
        )}
        <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 1 }}>
          Equipment Name
        </Typography>

        <CustomTextField
          //  select
          variant="outlined"
          value={fromValue?.name}
          onChange={handleChange}
          fullWidth
          name="name"
          placeholder="Enter name"
          error={!!errors.name} // Show error styling if there's an error
          InputLabelProps={{
            style: { color: errors.name ? "#D34040" : undefined },
          }}
          disabled={props?.selectedEquipment?.name === undefined ? false : true}
        ></CustomTextField>
        {errors.name && (
          <Typography variant="body2" color="#D34040">
            {errors.name}
          </Typography>
        )}
        <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 1 }}>
          Fuel type
        </Typography>
        <CustomTextField
          select
          variant="outlined"
          fullWidth
          name="fuelType"
          value={
            fromValue?.fuelType === "" || fromValue?.fuelType === undefined
              ? FUEL_TYPE_PLACEHOLDER_VALUE
              : fromValue?.fuelType
          }
          onChange={handleChange}
          placeholder={FUEL_TYPE_PLACEHOLDER_VALUE}
          error={!!errors.fuelType}
          InputLabelProps={{
            style: { color: errors.fuelType ? "#D34040" : undefined },
          }}
          SelectProps={{ MenuProps }}
          disabled={
            props.selectedEquipment?.fuelType === undefined ? false : true
          }
        >
          <MenuItem
            value={
              fromValue?.fuelType === "" || fromValue?.fuelType === undefined
                ? FUEL_TYPE_PLACEHOLDER_VALUE
                : fromValue?.fuelType
            }
            disabled
          >
            {FUEL_TYPE_PLACEHOLDER_VALUE}
          </MenuItem>

          {/* Map through FuelTypeEnum for dropdown options */}
          {fuelType.map((item, index) => (
            <MenuItem key={`fuelType__${item}${index}`} value={item}>
              {item}
            </MenuItem>
          ))}
        </CustomTextField>
        {errors.fuelType && (
          <Typography variant="body2" color="#D34040">
            {errors.fuelType}
          </Typography>
        )}

        <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 1 }}>
          No of Equipment
        </Typography>

        <CustomTextField
          type="text"
          inputMode="numeric"
          disabled={alreadyFacility}
          variant="outlined"
          value={
            noOfEquipment === "" ||
            noOfEquipment === null ||
            noOfEquipment === undefined
              ? ""
              : noOfEquipment
          }
          onChange={(e) => {
            const digitsOnly = e.target.value.replace(/\D/g, "");
            if (digitsOnly === "") {
              setNoOfEquipment("");
              handleChange({
                target: { name: "noOfEquipment", value: "" },
              });
              return;
            }
            let num = parseInt(digitsOnly, 10);
            if (!Number.isFinite(num)) return;
            num = Math.min(100, num);
            setNoOfEquipment(num);
            handleChange({
              target: { name: "noOfEquipment", value: String(num) },
            });
          }}
          fullWidth
          name="noOfEquipment"
          placeholder="Enter No of Equipment"
          error={!!errors.noOfEquipment}
          InputLabelProps={{
            style: { color: errors.noOfEquipment ? "#D34040" : undefined },
          }}
        />
        <br />
        {errors.noOfEquipment && (
          <Typography variant="body2" color="#D34040">
            {errors.noOfEquipment}
          </Typography>
        )}

        <Dialog
          open={deleteDialog}
          onClose={() => setDeleteDialog(false)}
          BackdropProps={{
            style: {
              backgroundColor: "rgba(0, 0, 0, 0.02)", // Adjust the opacity as needed (0.3 is lighter)
            },
          }}
        >
          <DialogTitle>Confirm Delete</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Do you really want to delete this entry?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setDeleteDialog(false)} color="primary">
              Cancel
            </Button>
            {/* onClick={() => deleteEquipment(index)} */}
            <Button onClick={handleDeleteAgree} color="secondary">
              Confirm
            </Button>
          </DialogActions>
        </Dialog>
        {/* Dynamically Render Equipment Forms */}
        {equipments.length > 0 &&
          equipments.map((equipment, index) => (
            <Box key={index} sx={{ mt: 2 }}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography
                  variant="h6"
                  sx={{ fontSize: "16px", fontWeight: "bold" }}
                >
                  Equipment {index + 1}
                </Typography>

                <Box>
                  <IconButton onClick={() => toggleEquipment(index)}>
                    {openMachines[index] ? (
                      <ArrowDropUpIcon />
                    ) : (
                      <ArrowDropDownIcon />
                    )}
                  </IconButton>

                  <IconButton
                    onClick={() => deleteEquipment(index)}
                    color="error"
                  >
                    <DeleteIcon />
                  </IconButton>
                </Box>
              </Box>
              {errors[`equipment_${index}_brand`] && (
                <Typography variant="body2" color="#D34040">
                  {`Please fill Equipment ${index + 1} form`}
                </Typography>
              )}

              <Collapse in={openMachines[index]} timeout="auto" unmountOnExit>
                <Box sx={{ mt: 1 }}>
                  <Typography
                    variant="subtitle1"
                    sx={{ fontWeight: "bold", mt: 1 }}
                  >
                    Unique ID
                  </Typography>
                  <CustomTextField
                    variant="outlined"
                    value={equipment.uniqueID}
                    placeholder="Enter ID"
                    fullWidth
                    error={!!errors[`equipment_${index}_uniqueID`]}
                    onChange={(e) =>
                      handleFieldChange(index, "uniqueID", e.target.value)
                    }
                  />
                  {errors[`equipment_${index}_uniqueID`] && (
                    <Typography variant="body2" color="#D34040">
                      {errors[`equipment_${index}_uniqueID`]}
                    </Typography>
                  )}
                  <Typography
                    variant="subtitle1"
                    sx={{ fontWeight: "bold", mt: 1 }}
                  >
                    Brand
                  </Typography>
                  <CustomTextField
                    variant="outlined"
                    value={equipment.brand}
                    placeholder="Enter Brand"
                    fullWidth
                    onChange={(e) =>
                      handleFieldChange(index, "brand", e.target.value)
                    }
                  />
                  {errors[`equipment_${index}_brand`] && (
                    <Typography variant="body2" color="#D34040">
                      {errors[`equipment_${index}_brand`]}
                    </Typography>
                  )}
                  <Typography
                    variant="subtitle1"
                    sx={{ fontWeight: "bold", mt: 1 }}
                  >
                    Model
                  </Typography>
                  <CustomTextField
                    variant="outlined"
                    value={equipment.model}
                    placeholder="Enter Model"
                    fullWidth
                    onChange={(e) =>
                      handleFieldChange(index, "model", e.target.value)
                    }
                  // error={!!errors[`equipment_${index}_model`]}
                  // helperText={errors[`equipment_${index}_model`]}
                  />
                  {errors[`equipment_${index}_model`] && (
                    <Typography variant="body2" color="#D34040">
                      {errors[`equipment_${index}_model`]}
                    </Typography>
                  )}
                  <Typography
                    variant="subtitle1"
                    sx={{ fontWeight: "bold", mt: 1 }}
                  >
                    Rated Fuel Consumption
                  </Typography>
                  <CustomTextField
                    variant="outlined"
                    value={equipment.ratedFuelConsumption}
                    placeholder="Amount"
                    fullWidth
                    onChange={(e) =>
                      handleFieldChange(
                        index,
                        "ratedFuelConsumption",
                        e.target.value
                      )
                    }
                  />
                  {errors[`equipment_${index}_ratedFuelConsumption`] && (
                    <Typography variant="body2" color="#D34040">
                      {errors[`equipment_${index}_ratedFuelConsumption`]}
                    </Typography>
                  )}

                  <Typography
                    variant="subtitle1"
                    sx={{ fontWeight: "bold", mt: 1 }}
                  >
                    Unit of Fuel Consumption
                  </Typography>

                  <CustomTextField
                    variant="outlined"
                    value={UnitofFuelConsumption}
                    placeholder="Unit of Fuel consumption"
                    fullWidth
                    disabled={true}
                    error={!!errors.unitOfFuelConsumption}
                    InputLabelProps={{
                      style: {
                        color: errors.unitOfFuelConsumption
                          ? "#D34040"
                          : undefined,
                      },
                    }}
                  />
                  {/* 
        ></CustomTextField> */}
                  <br />
                  {errors.unitOfFuelConsumption && (
                    <Typography variant="body2" color="#D34040">
                      {errors.unitOfFuelConsumption}
                    </Typography>
                  )}

                  {/* <CustomTextField
                    select
                    variant="outlined"
                    fullWidth
                    value={
                      equipment.unitOfFuelConsumption === "" || undefined
                        ? "Tap to Select"
                        : equipment.unitOfFuelConsumption
                    }
                    // value={equipment.unitOfFuelConsumption || "Tap to Select"}
                    onChange={(e) =>
                      handleFieldChange(
                        index,
                        "unitOfFuelConsumption",
                        e.target.value
                      )
                    }
                    placeholder="Tap to Select"
                    error={!!errors[`equipment_${index}_unitOfFuelConsumption`]}
                    InputLabelProps={{
                      style: {
                        color: errors[
                          `equipment_${index}_unitOfFuelConsumption`
                        ]
                          ? "#D34040"
                          : undefined,
                      },
                    }}
                  >
                    <MenuItem
                      value={
                        equipment?.unitOfFuelConsumption === "" || undefined
                          ? "Tap to Select"
                          : equipment.unitOfFuelConsumption
                      }
                      disabled
                    >
                      Tap to Select
                    </MenuItem>

                    {unitConsumption.map((item, index) => (
                      <MenuItem
                        key={`unitConsumption__${item}${index}`}
                        value={item}
                        sx={{
                          "&:hover": {
                            backgroundColor: "#f5f5f5",
                          },
                          padding: "10px 20px",
                          borderRadius: "4px",
                        }}
                      >
                        {item} 
                      </MenuItem>
                    ))}
                  </CustomTextField>
                  {errors[`equipment_${index}_unitOfFuelConsumption`] && (
                    <Typography variant="body2" color="#D34040">
                      {errors[`equipment_${index}_unitOfFuelConsumption`]}
                    </Typography>
                  )} */}
                </Box>
              </Collapse>
            </Box>
          ))}

        {alreadyFacility && (
          <Button
            onClick={addMoreEquipment}
            variant="contained"
            sx={{ mt: 2, backgroundColor: "#0a3f73" }}
          >
            Add Equipment
          </Button>
        )}

        <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 1 }}>
          Remark
        </Typography>

        <TextField
          multiline
          rows={2}
          variant="outlined"
          fullWidth
          name="remark"
          value={fromValue?.remark}
          onChange={handleChange}
          placeholder="Brief"
        />
        {errors.incharge && (
          <Typography variant="body2" color="#D34040">
            {errors.incharge}
          </Typography>
        )}

        {/* <Box> */}
        <Button
          variant="contained"
          sx={{
            backgroundColor: "#0a3f73",
            textTransform: "none",
            marginTop: "10%",
          }}
          onClick={Save}
        >
          Submit
        </Button>
        {/* </Box> */}
      </Box>
    </Box>
  );

  return (
    <div style={{ zIndex: 2000 }}>
      <Drawer
        sx={{
          backgroundColor: "transparent",
          "& .MuiDrawer-paper": {
            backgroundColor: "transparent", // Make paper transparent
            boxShadow: "none", // Optional: Remove any shadow
          },
        }}
        anchor="right"
        open={props.addFacility}
        onClose={() => {
          handleClose();
        }}
      >
        {list()}
      </Drawer>
    </div>
  );
}

export default AddEquipment;

//// custom textfield

const CustomTextField = styled(TextField)(({ theme }) => ({
  "& .MuiInputBase-root": {
    height: "40px", // Adjust height as needed
  },
  "& .MuiSelect-select": {
    height: "56px", // Adjust height as needed
    display: "flex",
    alignItems: "center",
  },
}));
